// Giấy tờ nộp ở trang tài khoản, không còn chụp ngay trong luồng đăng ký.
export const LICENSE_PAGE_URL = '/my-account?tab=3';

export enum ConfirmType {
  Selection = 'Selection',
  Close = 'Close',
}

export enum ConfirmText {
  Selection = 'Kích hoạt ngay',
  Close = 'Tiếp tục xác thực',
}
